import axios from "./axiosInstance";

const termsandconditionApi = {
  details: () => axios.post("terms-condition"),
};

export default termsandconditionApi;
